<template>
  <TsSection append-class="bg-natural-soft-white pt-5">
    <div class="text-center">
      <TsTypography variant="p" as="h2" align="center"> {{ title }} </TsTypography>
      <TsInput
        type="text"
        placeholder="Search for brands..."
        icon="material-symbols:search"
        iconPosition="left"
        rounded
        v-model="searchQuery"
        appendClass="bg-idle-white lg:w-[400px] w-[280px]   inline-block items-center"
      />
    </div>
    <div v-if="builderStore.brands_state.status === 'loading'" class="mb-4">
      <TsLoadingCircularSpinner></TsLoadingCircularSpinner>
    </div>
    <div v-if="builderStore.brands_state.status === 'idle'" class="mb-4">
      <TsLoadingCircularSpinner></TsLoadingCircularSpinner>
    </div>
    <div v-if="builderStore.brands_state.status === 'failed'">
      <div class="mt-4 pb-4">
        <TsTypography variant="p" as="h3" align="center">
          {{
            useTranslation(
              "noBrandsFound",
              "Kan de merken momenteel niet laden. Probeer het later opnieuw."
            )
          }}
        </TsTypography>
      </div>
    </div>
    <div v-if="builderStore.brands_state.status === 'success'">
      <TransitionGroup name="animatedlist">
        <div v-if="computedBrandList.length <= 0">
          <div class="mt-4 pb-4">
            <TsTypography variant="p" as="h3" align="center">
              {{
                useTranslation(
                  "noMatchingBrandFound",
                  "Kon geen overeenkomend merk vinden"
                )
              }}
            </TsTypography>
          </div>
        </div>
        <div v-else>
          <TsGrid class="py-5" :cols="6" :mobileCols="1">
            <TsColumn v-for="(brand, index) in computedBrandList" :key="index">
              <TsCardGuarantee
                v-if="
                  computeVisiblity(
                    brand.data.topBrand.logo,
                    brand.data.guaranteeRegistration.buttonText,
                    brand.data.guaranteeRegistration.link
                  )
                "
                :image="brand.data.topBrand.logo"
                :alt="brand.data.topBrand.logoAlt || 'brand logo'"
                :button-cta="brand.data.guaranteeRegistration.buttonText"
                :link="brand.data.guaranteeRegistration.link"
                :should-open-in-new-tab="
                  brand.data.guaranteeRegistration.openInNewTab
                "
              />
            </TsColumn>
          </TsGrid>
        </div>
      </TransitionGroup>
    </div>
  </TsSection>
</template>

<script setup lang="ts">

const TsLoadingCircularSpinner = defineAsyncComponent(
    () => import('~/components/organisms/TsLoadingCircularSpinner.vue')
);

const TsCardGuarantee = defineAsyncComponent(
    () => import('~/components/organisms/TsCardGuarantee.vue')
);

const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);


const searchQuery = ref("");
const fuse = ref();
const builderStore = useBuilderStore();
const brandsWithRegistration = ref<any>([]);

type Props = {
  title?: string;
};

const props = withDefaults(defineProps<Props>(), {
  title: "Garantie",
});

onMounted(async () => {
  const { default: Fuse } = await import('fuse.js');

  if (builderStore.brands.length <= 0) {
    await builderStore.fetchAllBrands();
  }
  brandsWithRegistration.value = builderStore.brands.filter(
    (brand) => brand.data?.guaranteeRegistration
  );
  if (builderStore.brands.length <= 0) {
    await builderStore.fetchAllBrands();
  }
  brandsWithRegistration.value = builderStore.brands.filter(
    (brand) => brand.data?.guaranteeRegistration
  );

  fuse.value = new Fuse(brandsWithRegistration.value, {
    keys: ["data.title"],
    threshold: 0.3, // Sensitivity for category name search
  });
});

const computeVisiblity = (image: string, buttonCta: string, link: string) => {
  if (image && buttonCta && link) {
    return true;
  }
  return false;
};

const computedBrandList = computed(() => {
  const query = searchQuery.value.trim();

  if (!query) {
    return brandsWithRegistration.value;
  }

  // Use Fuse to search for matches
  const results = fuse.value.search(query);
  return results.map((result: any) => result.item || result);
});
</script>
